import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { ReactComponent as GoogleIcon } from 'assets/static/googleIcon.svg';
import { Auth } from 'aws-amplify';

export const SocialSignIn = () => {
  return (
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-white px-2 text-gray-500">Or continue with</span>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-3">
        <div>
          <button
            onClick={() => {
              Auth.federatedSignIn(
                // @ts-ignore
                { provider: CognitoHostedUIIdentityProvider.Google },
                {},
                {
                  zoneinfo: 'Europe/Minsk',
                },
              );
            }}
            className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-500 shadow-sm md:hover:bg-gray-50"
          >
            <span className="sr-only">Sign in with Google</span>
            <GoogleIcon className="h-6 w-6" />
          </button>
        </div>
      </div>
    </div>
  );
};
